module.exports = __webpack_public_path__ + "static/img/yarou.a814b428.png";